import {DEFAULT_REDIRECT, SHOW_HTML_IN_MENU} from '../config/config.js'
import {PERMS} from '../config/permissions'

// use import for system components
// for prevent recursive async chunk loading error if user have wrong cached files
// шаблоны
import MainLayout from '../common/layout/main-layout.vue'
import AuthLayout from '../common/layout/auth-layout.vue'
import AccountUserProfileLayout from '../app/account/UserProfileLayout.vue'

// main
import MainError from '../app/main/Error.vue'

// авторизация/регистрация
import AuthLogin from '../app/auth/region.saas/Login.vue'
import AuthRegisterSetPassword from '../app/auth/RegisterSetPassword.vue'
import AuthRequestResetPassword from '../app/auth/RequestResetPassword.vue'

// личный кабинет пользователя
const AccountUserProfile = () => import(/* webpackChunkName: "saas.account" */ '../app/account/UserProfile.vue')

// карта
const GeoObjects = () => import(/* webpackChunkName: "saas.geo" */ '../app/geo/region.saas/Objects.vue')

// АТУ: административно терр устройств
const AtuObjects = () => import(/* webpackChunkName: "saas.atu" */ '../app/atu/Objects.vue')
const AtuObjectUpdate = () => import(/* webpackChunkName: "saas.atu" */ '../app/atu/region.saas/ObjectUpdate.vue')

// отходообразователи
const GarbageDefenses = () => import(/* webpackChunkName: "saas.garbage" */ '../app/garbage/Defenses.vue')
const GarbageDefenseUpdate = () => import(/* webpackChunkName: "saas.garbage" */ '../app/garbage/DefenseUpdate.vue')
const GarbageOrganizations = () => import(/* webpackChunkName: "saas.garbage" */ '../app/garbage/Organizations.vue')
const GarbageOrganizationUpdate = () => import(/* webpackChunkName: "saas.garbage" */ '../app/garbage/OrganizationUpdate.vue')
const GarbageCountryCommunities = () => import(/* webpackChunkName: "saas.garbage" */ '../app/garbage/CountryCommunities.vue')
const GarbageCountryCommunityUpdate = () => import(/* webpackChunkName: "saas.garbage" */ '../app/garbage/CountryCommunityUpdate.vue')
const GarbageGarages = () => import(/* webpackChunkName: "saas.garbage" */ '../app/garbage/Garages.vue')
const GarbageGarageUpdate = () => import(/* webpackChunkName: "saas.garbage" */ '../app/garbage/GarageUpdate.vue')
const GarbageIndividualAreas = () => import(/* webpackChunkName: "saas.garbage" */ '../app/garbage/IndividualAreas.vue')
const GarbageIndividualAreaUpdate = () => import(/* webpackChunkName: "saas.garbage" */ '../app/garbage/IndividualAreaUpdate.vue')
const GarbageManagers = () => import(/* webpackChunkName: "saas.garbage" */ '../app/garbage/Managers.vue')
const GarbageManagerUpdate = () => import(/* webpackChunkName: "saas.garbage" */ '../app/garbage/ManagerUpdate.vue')
const GarbageMedics = () => import(/* webpackChunkName: "saas.garbage" */ '../app/garbage/Medics.vue')
const GarbageMedicUpdate = () => import(/* webpackChunkName: "saas.garbage" */ '../app/garbage/MedicUpdate.vue')
const GarbageSettlements = () => import(/* webpackChunkName: "saas.garbage" */ '../app/garbage/Settlements.vue')
const GarbageSettlementUpdate = () => import(/* webpackChunkName: "saas.garbage" */ '../app/garbage/SettlementUpdate.vue')

// мсн: места сбора и накопления
const MsnSeparateCollections = () => import(/* webpackChunkName: "saas.msn" */ '../app/msn/SeparateCollections.vue')
const MsnSeparateCollectionUpdate = () => import(/* webpackChunkName: "saas.msn" */ '../app/msn/SeparateCollectionUpdate.vue')
const MsnWithContainers = () => import(/* webpackChunkName: "saas.msn" */ '../app/msn/WithContainers.vue')
const MsnWithContainerUpdate = () => import(/* webpackChunkName: "saas.msn" */ '../app/msn/WithContainerUpdate.vue')
const MsnWithoutContainers = () => import(/* webpackChunkName: "saas.msn" */ '../app/msn/WithoutContainers.vue')
const MsnWithoutContainerUpdate = () => import(/* webpackChunkName: "saas.msn" */ '../app/msn/WithoutContainerUpdate.vue')

// импорт файлов
const ImportImportExcel = () => import(/* webpackChunkName: "saas.import" */ '../app/import/ImportExcel.vue')

// несанкцс свалки
const UnauthorizedHeapUpdate = () => import(/* webpackChunkName: "saas.unauthorized" */ '../app/unauthorized/HeapUpdate.vue')

// операторы
const RegistryOperatorAllUpdate = () => import(/* webpackChunkName: "saas.registry" */ '../app/registry/OperatorAllUpdate.vue')
const RegistryObjectUpdate = () => import(/* webpackChunkName: "saas.registry" */ '../app/registry/ObjectUpdate.vue')

// администрирование
const AccessUsers = () => import(/* webpackChunkName: "saas.access" */ '../app/access/Users.vue')
const AccessUsersGroups = () => import(/* webpackChunkName: "saas.access" */ '../app/access/UsersGroups.vue')
const AccessUserUpdate = () => import(/* webpackChunkName: "saas.access" */ '../app/access/UserUpdate.vue')
const AccessUserGroupsUpdate = () => import(/* webpackChunkName: "saas.access" */ '../app/access/UserGroupsUpdate.vue')
const AccessJournals = () => import(/* webpackChunkName: "saas.access" */ '../app/access/Journals.vue')

// аналитика
const AnalyticCharts = () => import(/* webpackChunkName: "saas.analytic" */ '../app/analytic/Charts.vue')
const AnalyticChart = () => import(/* webpackChunkName: "saas.analytic" */ '../app/analytic/Chart.vue')
const AnalyticReports = () => import(/* webpackChunkName: "saas.analytic" */ '../app/analytic/Reports.vue')
const AnalyticReportDownload = () => import(/* webpackChunkName: "saas.analytic" */ '../app/analytic/ReportDownload.vue')

// разработка
const DevelopmentSettingUpdate = () => import(/* webpackChunkName: "saas.development" */ '../app/development/SettingUpdate.vue')

// верстка
const reestrPage = () => import(/* webpackChunkName: "saas.verstka" */ '../components/pages/verstka/reestr.vue')
const reestrDocsPage = () => import(/* webpackChunkName: "saas.verstka" */ '../components/pages/verstka/reestrDocs.vue')

const verstka = [
  {
    path: 'reestrDocs', name: 'verstka.reestrDocs',
    meta: {title: 'Реестр договоров'},
    component: reestrDocsPage
  },
  {
    path: 'reestr', name: 'verstka.reestr',
    meta: {title: 'Реестр'},
    component: reestrPage
  }
]
let verstkaRoutes = { path: '/verstka/', component: MainLayout, name: 'verstka', meta: {title: 'Страницы верстки', number: '13'},
  redirect: { name: 'verstka.reestrDocs' },
  children: verstka
}

let routes = [
  { path: '/main', name: 'main', component: MainLayout, meta: {requiresAuth: false},
    children: [
      {path: 'error', name: 'main.error', component: MainError, meta: {requiresAuth: false, title: 'Ошибка', noRouteCheck: true}}
    ]
  },
  { path: '/auth', name: 'auth', component: AuthLayout, meta: {requiresAuth: false},
    children: [
      {path: 'login', name: 'auth.login', component: AuthLogin, alias: '/login', meta: {requiresAuth: false, title: 'Вход'}},
      {path: 'set-password', name: 'auth.registerSetPassword', component: AuthRegisterSetPassword, alias: '/set-password', meta: {requiresAuth: false, havePerms: [PERMS.CREATE, PERMS.EDIT], title: 'Установка пароля'}},
      {path: 'request-reset-password', name: 'auth.requestResetPassword', component: AuthRequestResetPassword, alias: '/request-reset-password', meta: {requiresAuth: false, havePerms: [PERMS.CREATE, PERMS.EDIT], title: 'Восстановление пароля'}}
    ]
  },
  { path: '/terShema', component: MainLayout, name: 'geo', meta: {title: 'Территориальная схема', number: '01'},
    redirect: { name: 'geo.objects' },
    children: [
      {
        path: '/', component: GeoObjects, name: 'geo.objects', meta: {title: 'Карта объектов'},
        children: [
          {path: 'defense-update/:id', name: 'geo.objects.defense.update', component: GarbageDefenseUpdate, meta: {requiresAuth: false}},
          {path: 'organization-update/:id', name: 'geo.objects.organization.update', component: GarbageOrganizationUpdate, meta: {requiresAuth: false}},
          {path: 'medic-update/:id', name: 'geo.objects.medic.update', component: GarbageMedicUpdate, meta: {requiresAuth: false}},
          {path: 'manager-update/:id', name: 'geo.objects.manager.update', component: GarbageManagerUpdate, meta: {requiresAuth: false}},
          {path: 'individual-area-update/:id', name: 'geo.objects.individualArea.update', component: GarbageIndividualAreaUpdate, meta: {requiresAuth: false}},
          {path: 'country-community-update/:id', name: 'geo.objects.countryCommunity.update', component: GarbageCountryCommunityUpdate, meta: {requiresAuth: false}},
          {path: 'garage-update/:id', name: 'geo.objects.garage.update', component: GarbageGarageUpdate, meta: {requiresAuth: false}},
          {path: 'with-container-update/:id', name: 'geo.objects.withContainer.update', component: MsnWithContainerUpdate, meta: {requiresAuth: false}},
          {path: 'without-container-update/:id', name: 'geo.objects.withoutContainer.update', component: MsnWithoutContainerUpdate, meta: {requiresAuth: false}},
          {path: 'separate-update/:id', name: 'geo.objects.separate.update', component: MsnSeparateCollectionUpdate, meta: {requiresAuth: false}},
          {path: 'heap-update/:id', name: 'geo.objects.heap.update', component: UnauthorizedHeapUpdate, meta: {requiresAuth: false}},
          {path: 'unauth-update/:id', name: 'geo.objects.unauth.update', component: RegistryObjectUpdate, meta: {requiresAuth: false}},
          {path: 'object-update/:id', name: 'geo.objects.object.update', component: RegistryObjectUpdate, meta: {requiresAuth: false}},
          {path: 'settlement-update/:id', name: 'geo.objects.settlement.update', component: GarbageSettlementUpdate, meta: {requiresAuth: false}},
          {path: 'operator-update/:id', name: 'geo.objects.operator.update', component: RegistryOperatorAllUpdate, meta: {requiresAuth: false}}
        ]
      }
    ]
  },
  { path: '/admTerUstr', component: MainLayout, name: 'atu', meta: {title: 'Административно-территориальное устройство', number: '02'},
    redirect: { name: 'atu.objects' },
    children: [
      {
        path: '', name: 'atu.objects', component: AtuObjects, meta: {title: 'Административно-территориальное устройство', hideInMenu: true},
        children: [
          {path: 'update/:id', name: 'atu.objects.update', component: AtuObjectUpdate}
        ]
      }
    ]
  },
  { path: '/othodoobrazovateli', component: MainLayout, name: 'garbage', meta: {title: 'Отходообразователи', number: '03'},
    redirect: { name: 'garbage.organizations' },
    children: [
      {
        path: 'ip', component: GarbageOrganizations, name: 'garbage.organizations', meta: {title: 'Организация/ИП'},
        children: [
          {path: 'create', name: 'garbage.organizations.create', component: GarbageOrganizationUpdate},
          {path: 'update/:id', name: 'garbage.organizations.update', component: GarbageOrganizationUpdate}
        ]
      },
      {
        path: 'minob', component: GarbageDefenses, name: 'garbage.defenses', meta: {title: 'Объекты министерства обороны'},
        children: [
          {path: 'create', name: 'garbage.defenses.create', component: GarbageDefenseUpdate},
          {path: 'update/:id', name: 'garbage.defenses.update', component: GarbageDefenseUpdate}
        ]
      },
      {
        path: 'med', component: GarbageMedics, name: 'garbage.medics', meta: {title: 'Медицинские учреждения'},
        children: [
          {path: 'create', name: 'garbage.medics.create', component: GarbageMedicUpdate},
          {path: 'update/:id', name: 'garbage.medics.update', component: GarbageMedicUpdate}
        ]
      },
      {
        path: 'uprav', component: GarbageManagers, name: 'garbage.managers', meta: {title: 'Управляющие организации'},
        children: [
          {path: 'create', name: 'garbage.managers.create', component: GarbageManagerUpdate},
          {path: 'update/:id', name: 'garbage.managers.update', component: GarbageManagerUpdate}
        ]
      },
      {
        path: 'individ', component: GarbageIndividualAreas, name: 'garbage.individualAreas', meta: {title: 'Индивидуальное домовладение'},
        children: [
          {path: 'create', name: 'garbage.individualAreas.create', component: GarbageIndividualAreaUpdate},
          {path: 'update/:id', name: 'garbage.individualAreas.update', component: GarbageIndividualAreaUpdate}
        ]
      },
      {
        path: 'garden', component: GarbageCountryCommunities, name: 'garbage.countryCommunitys', meta: {title: 'Садовые, дачные партнерства'},
        children: [
          {path: 'create', name: 'garbage.countryCommunitys.create', component: GarbageCountryCommunityUpdate},
          {path: 'update/:id', name: 'garbage.countryCommunitys.update', component: GarbageCountryCommunityUpdate}
        ]
      },
      {
        path: 'garage', component: GarbageGarages, name: 'garbage.garages', meta: {title: 'Гаражно-строительные кооперативы'},
        children: [
          {path: 'create', name: 'garbage.garages.create', component: GarbageGarageUpdate},
          {path: 'update/:id', name: 'garbage.garages.update', component: GarbageGarageUpdate}
        ]
      },
      {
        path: 'village', component: GarbageSettlements, name: 'garbage.settlements', meta: {title: 'Деревни, поселки, села'},
        children: [
          {path: 'create', name: 'garbage.settlements.create', component: GarbageSettlementUpdate},
          {path: 'update/:id', name: 'garbage.settlements.update', component: GarbageSettlementUpdate}
        ]
      }
    ]
  },
  { path: '/places/', component: MainLayout, name: 'msn', meta: {title: 'Места сбора и накопления', number: '04'},
    redirect: { name: 'msn.withContainers' },
    children: [
      {
        path: 'container', component: MsnWithContainers, name: 'msn.withContainers', meta: {title: 'Контейнерные площадки'},
        children: [
          {path: 'create', name: 'msn.withContainers.create', component: MsnWithContainerUpdate},
          {path: 'update/:id', name: 'msn.withContainers.update', component: MsnWithContainerUpdate}
        ]
      },
      {
        path: 'noContainer', component: MsnWithoutContainers, name: 'msn.withoutContainers', meta: {title: 'Бесконтейнерный сбор'},
        children: [
          {path: 'create', name: 'msn.withoutContainers.create', component: MsnWithoutContainerUpdate},
          {path: 'update/:id', name: 'msn.withoutContainers.update', component: MsnWithoutContainerUpdate}
        ]
      },
      {
        path: 'vtors', component: MsnSeparateCollections, name: 'msn.separateCollections', meta: {title: 'Пункты сбора вторсырья'},
        children: [
          {path: 'create', name: 'msn.separateCollections.create', component: MsnSeparateCollectionUpdate},
          {path: 'update/:id', name: 'msn.separateCollections.update', component: MsnSeparateCollectionUpdate}
        ]
      },
    ]
  },
  { path: '/analytics/', component: MainLayout, name: 'analytic', meta: {title: 'Аналитика', number: '05'},
    redirect: { name: 'analytic.charts' },
    children: [
      {path: 'chart/:chartId', component: AnalyticChart, name: 'analytic.chart', meta: {title: 'График', hideInMenu: true}},
      {path: 'charts', component: AnalyticCharts, name: 'analytic.charts', meta: {title: 'Аналитика', hideInMenu: true}},
      {
        path: 'reports', component: AnalyticReports, name: 'analytic.reports', meta: {title: 'Отчеты', hideInMenu: true},
        children: [
          {path: 'report/:reportId/:windowType', name: 'analytic.reports.report', component: AnalyticReportDownload, meta: {title: 'Отчеты'}}
        ]
      }
    ]
  },
  { path: '/admin/', component: MainLayout, name: 'access', meta: {title: 'Администрирование', number: '06'},
    redirect: { name: 'access.users' },
    children: [
      { path: '', component: AccessUsers, name: 'access.users', meta: {title: 'Пользователи'},
        children: [
          {path: 'create', name: 'access.users.create', component: AccessUserUpdate},
          {path: 'update/:id', name: 'access.users.update', component: AccessUserUpdate}
        ]
      },
      { path: 'users-groups', component: AccessUsersGroups, name: 'access.usersGroups', meta: {title: 'Группы пользователей'},
        children: [
          {path: 'create', name: 'access.usersGroups.create', component: AccessUserGroupsUpdate},
          {path: 'update/:id', name: 'access.usersGroups.update', component: AccessUserGroupsUpdate}
        ]
      },
      { path: 'journals', component: AccessJournals, name: 'access.journals', meta: {title: 'Журнал изменений'}},
    ]
  },
  {path: '/import', component: MainLayout, name: 'import', meta: {title: 'Импорт данных', number: ' ', hideInMenu: true},
    children: [
      { path: 'excel', component: ImportImportExcel, name: 'import.importExcel', meta: {title: 'Импорт даннных', hideInMenu: true}}
    ]
  },
  { path: '/profile', component: AccountUserProfileLayout, name: 'account', meta: {title: 'Личный кабинет', number: '13', hideInMenu: true},
    redirect: { name: 'account.userProfile' },
    children: [
      { path: '', component: AccountUserProfile, name: 'account.userProfile', meta: {title: 'Личный кабинет', hideInMenu: true}}
    ]
  },
  { path: '/development', component: MainLayout, name: 'development', meta: {title: 'Разработка', number: '0', hideInMenu: true},
    redirect: { name: 'development.settingUpdate' },
    children: [
      { path: 'setting-update', component: DevelopmentSettingUpdate, name: 'development.settingUpdate', meta: {title: 'Меню разработки', hideInMenu: true}}
    ]
  },
  {path: '*', redirect: DEFAULT_REDIRECT.default}
]

if (SHOW_HTML_IN_MENU && SHOW_HTML_IN_MENU === true) {
  routes.push(verstkaRoutes)
}

export default {
  /* mode: 'history', */
  linkActiveClass: 'active',
  routes: routes
}
